import { Currency, ETHER, Token } from '@pancakeswap/sdk'
import { BinanceIcon, Ejoe, USDC, USDT, WETH } from '@pancakeswap/uikit'
import { useMemo } from 'react'
import styled from 'styled-components'
import { WrappedTokenInfo } from 'state/types'
import useHttpLocations from '../../hooks/useHttpLocations'
import getTokenLogoURL from '../../utils/getTokenLogoURL'
import Logo from './Logo'

const StyledLogo = styled(Logo) <{ size: string }>`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  border-radius: 50%;
`

export default function CurrencyLogo({
  currency,
  size = '24px',
  style,
}: {
  currency?: Currency
  size?: string
  style?: React.CSSProperties
}) {
  const uriLocations = useHttpLocations(currency instanceof WrappedTokenInfo ? currency.logoURI : undefined)

  const srcs: string[] = useMemo(() => {
    if (currency === ETHER || currency?.symbol === "WETH" || currency?.symbol === "EJOE" || currency?.symbol === "USDC" || currency?.symbol === "USDT") return []

    if (currency instanceof Token) {
      if (currency instanceof WrappedTokenInfo) {
        return [...uriLocations, getTokenLogoURL(currency.address)]
      }
      return [getTokenLogoURL(currency.address)]
    }
    return []
  }, [currency, uriLocations])

  if (currency === ETHER) {
    return <BinanceIcon width={size} style={style} />
  }
  
  if (currency?.symbol === "WETH") {
    return <WETH width={size} style={style} />
  }
  
  if (currency?.symbol === "EJOE") {
    return <Ejoe width={size} style={style} />
  }
  
  if (currency?.symbol === "USDC") {
    return <USDC width={size} style={style} />
  }
  
  if (currency?.symbol === "USDT") {
    return <USDT width={size} style={style} />
  }

  return <StyledLogo size={size} srcs={srcs} alt={`${currency?.symbol ?? 'token'} logo`} style={style} />
}
